









import { Component, Vue, Prop } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';

@Component
export default class PreviewTicketImage extends Vue {
    @Prop() public image: any;

    constructor() {
        super();
    }

    public cancel() {
        this.$store.commit(Mutations.SET_TICKET_IMAGE_PREVIEW_VISIBILITY, false);
    }

    public setAttacheSrc(src: string)  {
        return 'data:image/png;charset=utf-8;base64,' + src;
    }

    public beforeDestroy() {
        this.cancel();
    }
}
